/**
 * Contextual "unsaved changes" bar. Fixed to the bottom of the viewport,
 * full-width, orange — slides up the moment a screen becomes dirty so the
 * publish/save action is impossible to miss (replaces the easy-to-overlook
 * button in the page header). Used by every screen with a draft/publish flow.
 */
export function SaveBar({
  visible,
  pending,
  onDiscard,
  onPublish,
  label = "Publish",
  pendingLabel = "Saving…",
}: {
  /** Show the bar — typically `dirty && canWrite`. */
  visible: boolean;
  pending: boolean;
  onDiscard: () => void;
  onPublish: () => void;
  /** Primary action label, e.g. "Publish" or "Save". */
  label?: string;
  pendingLabel?: string;
}) {
  return (
    <div
      className="ad-savebar"
      data-visible={visible}
      role="region"
      aria-label="Unsaved changes"
      aria-hidden={!visible}
    >
      <span className="ad-savebar-msg">You have unsaved changes</span>
      <div className="ad-savebar-actions">
        <button
          type="button"
          className="ad-savebar-discard"
          onClick={onDiscard}
          disabled={pending}
          tabIndex={visible ? 0 : -1}
        >
          Discard
        </button>
        <button
          type="button"
          className="ad-savebar-publish"
          onClick={onPublish}
          disabled={pending}
          tabIndex={visible ? 0 : -1}
        >
          {pending ? pendingLabel : label}
        </button>
      </div>
    </div>
  );
}
